import { useQuery } from '@tanstack/react-query';

import {
  fetchPendingCompaniesCount,
  type PendingCompaniesCountResponse,
} from '@/api/v4/projects.api';
import { QueryKey } from '@/config/query-client';

import { projectIdState } from '../project.state';
import { useAtomValue } from 'jotai';
import { useUserPermissions } from '@/user/permissions/use-user-permissions';
import { PERMISSION } from '@/user/permissions/permission.type';

export const usePendingCompaniesCount = () => {
  const projectId = useAtomValue(projectIdState);
  const { hasRequiredPermission } = useUserPermissions();

  const getPendingCompaniesCount = ():
    | Promise<PendingCompaniesCountResponse>
    | undefined => {
    if (!projectId) return;

    return fetchPendingCompaniesCount(projectId);
  };

  return useQuery({
    queryKey: [QueryKey.PendingCompaniesCount, projectId],
    queryFn: getPendingCompaniesCount,
    enabled:
      !!projectId && hasRequiredPermission(PERMISSION.VIEW_PENDING_COMPANIES),
    retry: false,
    staleTime: 1000 * 60 * 2,
  });
};
